import {gql} from "@apollo/client";
import {Organization} from "@App/types";

export interface ContractDetailsQuery {
    organization: Organization
}

export const GET_CONTRACT_DETAILS = gql`
    query getContractDetails(
        $organization: ID!
        $agreementNumber: String
        $lastName: String
    ) {
        organization(id: $organization) {
            id
            uuid
            name
            contractDetails(agreementNumber: $agreementNumber, lastName: $lastName) {
                carId
                agreementNumber,
                name,
                street,
                city,
                postcode,
                earliestDeliveryDate,
                phone
            }
        }
    }
`
